module.exports = __webpack_public_path__ + "img/packshots-tablet(old).7b5137af.png";